import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import '../components/AdminLayout.css';

function fmtDate(d) { return d ? new Date(d).toLocaleString('tr-TR') : '-'; }

export default function Messages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterType, setFilterType] = useState('');
  const [selectedMsg, setSelectedMsg] = useState(null);

  useEffect(() => { fetchMessages(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function fetchMessages() {
    setLoading(true);
    try {
      const { data: rawMsgs, error } = await supabase
        .from('messages')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) { console.error('Messages error:', error); setLoading(false); return; }

      const userIds = [...new Set((rawMsgs || []).map(m => m.sender_id).filter(Boolean))];
      const noteIds = [...new Set((rawMsgs || []).map(m => m.note_id).filter(Boolean))];

      let profileMap = {}, noteMap = {};
      if (userIds.length > 0) {
        const { data: profiles } = await supabase.from('profiles').select('id, name, email').in('id', userIds);
        if (profiles) profiles.forEach(p => { profileMap[p.id] = p; });
      }
      if (noteIds.length > 0) {
        const { data: notes } = await supabase.from('notes').select('id, title').in('id', noteIds);
        if (notes) notes.forEach(n => { noteMap[n.id] = n; });
      }

      let enriched = (rawMsgs || []).map(m => ({
        ...m,
        sender: profileMap[m.sender_id] || null,
        related_note: noteMap[m.note_id] || null,
        is_deleted: !!m.deleted_at,
      }));

      if (filterType) enriched = enriched.filter(m => m.message_type === filterType);
      if (search) enriched = enriched.filter(m =>
        (m.sender?.name || '').toLowerCase().includes(search.toLowerCase()) ||
        (m.match_id || '').toLowerCase().includes(search.toLowerCase())
      );
      setMessages(enriched);
    } catch (e) { console.error(e); }
    setLoading(false);
  }

  return (
    <div>
      <div style={{ background: '#FFF8E6', border: '1px solid #FFE082', borderRadius: 10, padding: '10px 16px', marginBottom: 16, fontSize: '0.82rem', color: '#E65100', fontWeight: 500 }}>
        ⚠️ Mesaj içerikleri yalnızca destek veya güvenlik incelemesi gerektiğinde görüntülenmelidir.
      </div>

      <div className="admin-filter-bar">
        <input className="admin-search-input" placeholder="Gönderen veya Eşleşme ID..." value={search} onChange={e => setSearch(e.target.value)} />
        <select className="admin-select" value={filterType} onChange={e => setFilterType(e.target.value)}>
          <option value="">Tüm Tipler</option>
          <option value="text">Metin</option>
          <option value="note_share">Not Paylaşımı</option>
          <option value="system">Sistem</option>
        </select>
        <button className="btn-admin btn-admin-primary" onClick={fetchMessages}>Filtrele</button>
      </div>

      <div className="admin-table-wrapper">
        <div className="admin-table-scroll">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Gönderen</th>
                <th>Eşleşme ID</th>
                <th>Mesaj Tipi</th>
                <th>İlgili Not</th>
                <th>Tarih</th>
                <th>Durum</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr className="admin-loading-row"><td colSpan={6}>Yükleniyor...</td></tr>
              ) : messages.length === 0 ? (
                <tr className="admin-loading-row"><td colSpan={6}>Mesaj bulunamadı.</td></tr>
              ) : messages.map(m => (
                <tr key={m.id}>
                  <td>
                    <button style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#5784E6', fontWeight: 600, padding: 0, fontSize: '0.875rem', fontFamily: 'inherit' }} onClick={() => setSelectedMsg(m)}>
                      {m.sender?.name || '-'}
                    </button>
                  </td>
                  <td style={{ fontSize: '0.75rem', color: '#7A8BAD' }}>{m.match_id ? m.match_id.slice(0, 8) + '...' : '-'}</td>
                  <td><span className="badge badge-blue">{m.message_type || '-'}</span></td>
                  <td>{m.related_note?.title || '-'}</td>
                  <td>{fmtDate(m.created_at)}</td>
                  <td>{m.is_deleted ? <span className="badge badge-red">Silindi</span> : <span className="badge badge-green">Aktif</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="admin-table-footer">Toplam {messages.length} mesaj gösteriliyor</div>
      </div>

      {selectedMsg && (
        <div className="admin-drawer-overlay" onClick={() => setSelectedMsg(null)}>
          <div className="admin-drawer" onClick={e => e.stopPropagation()}>
            <div className="admin-drawer-header">
              <h3>Mesaj Detayı</h3>
              <button className="admin-drawer-close" onClick={() => setSelectedMsg(null)}>✕</button>
            </div>
            <div className="admin-drawer-body">
              <div className="detail-row"><label>Gönderen</label><span>{selectedMsg.sender?.name || '-'}</span></div>
              <div className="detail-row"><label>E-posta</label><span>{selectedMsg.sender?.email || '-'}</span></div>
              <div className="detail-row"><label>Eşleşme ID</label><span style={{ fontSize: '0.75rem', wordBreak: 'break-all' }}>{selectedMsg.match_id || '-'}</span></div>
              <div className="detail-row"><label>Mesaj Tipi</label><span><span className="badge badge-blue">{selectedMsg.message_type || '-'}</span></span></div>
              <div className="detail-row"><label>İlgili Not</label><span>{selectedMsg.related_note?.title || '-'}</span></div>
              <div className="detail-row"><label>Tarih</label><span>{fmtDate(selectedMsg.created_at)}</span></div>
              <hr className="detail-divider" />
              <div className="detail-row">
                <label>İçerik Önizlemesi</label>
                <div style={{ background: '#F4F6FF', borderRadius: 8, padding: '10px 12px', fontSize: '0.85rem', color: '#3D4F7C', marginTop: 4, wordBreak: 'break-word' }}>
                  {selectedMsg.text || '(İçerik yok)'}
                </div>
              </div>
              <p style={{ fontSize: '0.75rem', color: '#7A8BAD', fontStyle: 'italic', marginTop: 4 }}>
                Mesaj içerikleri yalnızca destek veya güvenlik incelemesi gerektiğinde görüntülenmelidir.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
